import { mdiAlarmLight, mdiCloseOutline, mdiEmoticonSadOutline, mdiMessageAlertOutline } from '@mdi/js'
import Icon from '@mdi/react'
import { useTranslation } from 'react-i18next'

import ThumbButton from '@/components/ThumbButton'
import { Box } from '@/components/ui/box'
import { Button } from '@/components/ui/button'
import { MenuContent, MenuItem, MenuItemGroup, MenuRoot, MenuTrigger } from '@/components/ui/menu'
import { IFeedbackProps } from '@/types/gigiChat/Feedback'

const Feedback = ({ updateFeedbackType, provideReason, feedback, setCurrentFeedback }: IFeedbackProps) => {
    const { t } = useTranslation()
    const iconSize = '18px'
    return (
        <Box py={3} display="flex" data-testid="chat-actions-feedback">
            <ThumbButton type="up" isSelected={feedback.type === 'positive'} onClick={() => updateFeedbackType('positive')} />
            {feedback.type === 'positive' && feedback.comment === null && (
                <Box mr="12px">
                    <Button
                        variant="feedback"
                        onClick={() => {
                            setCurrentFeedback()
                            provideReason('positive')
                        }}
                    >
                        {t('chat.feedback.menu.label')}
                    </Button>
                </Box>
            )}
            <ThumbButton type="down" isSelected={feedback.type === 'negative'} onClick={() => updateFeedbackType('negative')} />
            {feedback.type === 'negative' && feedback.comment === null && (
                <Box mr="12px">
                    <MenuRoot variant="feedback">
                        <MenuTrigger as={Button} onClick={setCurrentFeedback}>
                            {t('chat.feedback.menu.label')}
                        </MenuTrigger>
                        <MenuContent>
                            <MenuItemGroup title={t('chat.feedback.menu.title')}>
                                <MenuItem value={t('chat.feedback.menu.options.inaccurate')} onClick={() => provideReason('inaccurate')}>
                                    <Icon path={mdiCloseOutline} size={iconSize} />
                                    {t('chat.feedback.menu.options.inaccurate')}
                                </MenuItem>
                                <MenuItem value={t('chat.feedback.menu.options.unhelpful')} onClick={() => provideReason('unhelpful')}>
                                    <Icon path={mdiEmoticonSadOutline} size={iconSize} />
                                    {t('chat.feedback.menu.options.unhelpful')}
                                </MenuItem>
                                <MenuItem value={t('chat.feedback.menu.options.offensive')} onClick={() => provideReason('offensive')}>
                                    <Icon path={mdiAlarmLight} size={iconSize} />
                                    {t('chat.feedback.menu.options.offensive')}
                                </MenuItem>
                                <MenuItem value={t('chat.feedback.menu.options.other')} onClick={() => provideReason('other')}>
                                    <Icon path={mdiMessageAlertOutline} size={iconSize} />
                                    {t('chat.feedback.menu.options.other')}
                                </MenuItem>
                            </MenuItemGroup>
                        </MenuContent>
                    </MenuRoot>
                </Box>
            )}
        </Box>
    )
}

export default Feedback
